"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteTenantChangeEventMutation = exports.useFetchTenantAuditLogQuery = exports.useFetchTenantHistoryQuery = exports.useUpdateTenantMutation = exports.useDeleteTenantMutation = exports.useFetchTenantQuery = exports.useSearchTenantsQuery = exports.useFetchClientTenantsQuery = exports.useCreateTenantMutation = exports.tenantApi = void 0;
// api/tenantApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.tenantApi = (0, react_1.createApi)({
    reducerPath: "tenantApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["tenants"],
    endpoints: function (builder) { return ({
        createTenant: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/tenant/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["tenants"],
        }),
        fetchClientTenants: builder.query({
            query: function (obj) { return ({
                url: "/v1/tenant/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    areaId: obj.areaId,
                    partyType: obj.partyType,
                    isActive: obj.isActive,
                    deleted: obj.deleted,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["tenants"],
        }),
        searchTenants: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                if (obj.partyType)
                    params.partyType = obj.partyType;
                return {
                    url: "/v1/tenant/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["tenants"],
        }),
        fetchTenant: builder.query({
            query: function (tenantId) { return ({
                url: "/v1/tenant/fetch",
                method: "GET",
                params: {
                    _id: tenantId,
                },
            }); },
            providesTags: ["tenants"],
        }),
        fetchActiveTenantForSpecificArea: builder.query({
            query: function (areaId) { return ({
                url: "/v1/tenant/by-area",
                method: "GET",
                params: {
                    areaId: areaId,
                },
            }); },
            providesTags: ["tenants"],
        }),
        updateTenant: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/tenant/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["tenants"],
        }),
        deleteTenant: builder.mutation({
            query: function (_a) {
                var tenantId = _a.tenantId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tenant/remove",
                    method: "DELETE",
                    params: __assign({ _id: tenantId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["tenants"],
        }),
        fetchTenantHistory: builder.query({
            query: function (tenantId) { return ({
                url: "/v1/tenant/history",
                method: "GET",
                params: { _id: tenantId },
            }); },
            providesTags: function (_result, _err, tenantId) { return [{ type: "tenants", id: "history:".concat(tenantId) }]; },
        }),
        fetchTenantAuditLog: builder.query({
            query: function (_a) {
                var tenantId = _a.tenantId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/tenant/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: tenantId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "tenants", id: "audit:".concat(arg.tenantId) }]; },
        }),
        deleteTenantChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tenant/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "tenants", id: "audit:".concat(arg.tenantId) },
                { type: "tenants", id: "history:".concat(arg.tenantId) },
            ]; },
        }),
    }); },
});
exports.useCreateTenantMutation = exports.tenantApi.useCreateTenantMutation, exports.useFetchClientTenantsQuery = exports.tenantApi.useFetchClientTenantsQuery, exports.useSearchTenantsQuery = exports.tenantApi.useSearchTenantsQuery, exports.useFetchTenantQuery = exports.tenantApi.useFetchTenantQuery, exports.useDeleteTenantMutation = exports.tenantApi.useDeleteTenantMutation, exports.useUpdateTenantMutation = exports.tenantApi.useUpdateTenantMutation, exports.useFetchTenantHistoryQuery = exports.tenantApi.useFetchTenantHistoryQuery, exports.useFetchTenantAuditLogQuery = exports.tenantApi.useFetchTenantAuditLogQuery, exports.useDeleteTenantChangeEventMutation = exports.tenantApi.useDeleteTenantChangeEventMutation;
